const API_ROUTES = {
  ANSWER_QUESTION: '/form/questions/response',
  CANCEL_SUBSCRIPTION: (de_gid: string) => `/user/subscription/${de_gid}/cancel`,
  GET_CONTRIBUTION_SUMMARIES: '/user/contribution_summaries',
  GET_EVENT: (query_str: string) => `/pages/event${query_str}`,
  GET_FAQS: (type: string) => `/faqs/?faq_type=${type}`,
  GET_IMPACT_REPORT: (election_year: number) => `/user/impact_report/${election_year}`,
  GET_RECOMMENDATIONS: '/user/recommendations',
  GET_FILTERS: '/filters',
  GET_GALLERY_ITEMS: '/media',
  GET_TRANSACTIONS: '/user/transactions',
  GET_QUESTIONS: '/form/questions',
  GET_RECIPIENTS: '/recipients',
  GET_SETS: (query_str?: string) => `/sets/${query_str}`,
  GET_SITE_CONFIG: (section?: string) => `/component_config?${section}`,
  GET_SUBSCRIPTIONS: '/user/subscriptions',
  GET_DONATE_PAGE: (query_str: string) => `/pages/donate/${query_str}`,
  GET_PAGES: '/pages',
  GET_SHOPPING_CART_RECIPIENTS_FUZZY_SEARCH: (query_str: string) =>
    `/shopping-cart-search-recipients${query_str}`,
  GET_SHOPPING_CART_SEARCH_CONFIG: (query_str: string) =>
    `/shopping-cart-search-config${query_str}`,
  FUNDING_GAP: '/funding_gap',
  PAY: '/pay',
  PAY_DAF: '/pay/daf/intent',
  PAY_STRIPE: '/transactions/charge',
  PAY_STRIPE_EVENT: '/transactions/charge/event',
  PAY_STRIPE_SUBSCRIPTION: '/transactions/subscription',
  PAYMENTS: '/payments',
  REPORT_EMAIL_QUEUE: (report_type: string) => `/report_email_queue/${report_type}`,
  SAVED_DONOR_SHOPPING_CARTS: '/saved-donor-shopping-carts',
  SAVED_DONOR_SHOPPING_CART: (cart_id: string) => `/saved-donor-shopping-carts/${cart_id}`,
  SAVED_DONOR_SHOPPING_CART_COMPLETE: (cart_id: string) =>
    `/saved-donor-shopping-carts/${cart_id}/complete`,
  SAVED_DONOR_SHOPPING_CART_CURRENT: '/saved-donor-shopping-carts/current',
  TRANSACTION_WIRE: '/transactions/wire',
  USER_CHAT: '/user/chat',
  USER_GIVING_HISTORY_DOWNLOAD: '/user/giving_history/download',
  USER_LOGIN: '/user/login',
  USER_PROFILE: '/user/profile',
  USER_STRIPE: '/user/stripe',
  USER_STRIPE_SESSION: '/user/stripe/session',
  USER_STRIPE_CUSTOMER_PORTAL: '/user/stripe/portal',
  USER_STRIPE_SUBSCRIPTIONS: '/user/stripe/subscriptions',
};

export default API_ROUTES;
